export default "__VITE_ASSET__BCwzhxiK__"